import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import Modal from '../Modal/Modal';
import Text from '../Text/Text';
import CustomSelect from '../Select/CustomSelect';
import postFedexPickup, { clearPostFedexPickup } from '../../thunks/fedex/pickup';
import Alert from '../Alert/Alert';
import AlertType from '../../common/alertType';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';

const FedexPickupModal = ({ visible, toggleVisible }) => {
  const dispatch = useDispatch();
  const {
    postFedexPickup: {
      loading,
      data: fedexResponse,
      error,
    }
  } = useSelector((state) => ({
    postFedexPickup: state?.postFedexPickup,
  }), shallowEqual);
  const dateTypeList = [
    { label: 'Future day', value: 'FUTURE_DAY' },
    { label: 'Same day', value: 'SAME_DAY' },
    { label: 'Custom', value: 'CUSTOM' }
  ];

  const carrierCodeList = [
    { label: 'FedEx Express', value: 'FDXE' },
    { label: 'FedEx Ground', value: 'FDXG' }
  ];
  const {
    values,
    setFieldValue,
    handleSubmit
  } = useFormik({
    initialValues: {
      isFuture: dateTypeList[0],
      isExpress: carrierCodeList[0],
    },
    onSubmit: (val) => {
      const isFuture = val?.isFuture?.value === 'FUTURE_DAY';
      const isExpress = val?.isExpress?.value === 'FDXE';
      const pickupDate = val?.pickupDate;
      dispatch(clearPostFedexPickup());
      dispatch(postFedexPickup({
        isFuture,
        isExpress,
        ...(values?.isFuture?.value === 'CUSTOM' && {
          pickupDate: `${DateTime.fromJSDate(pickupDate).toFormat('yyyy-MM-dd')}T09:00:00`
        }),
      }));
    }
  });

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Fedex Pickup"
      saveText={loading ? 'Loading...' : 'Request'}
      canSave={loading}
      hideCloseBtn
      onSave={handleSubmit}
      hideSaveBtn={fedexResponse?.transactionId}
    >
      <div className="customScroll">
        <div className="flex1">
          <Text text="Part type:" styleContainer="mb-[6px]" textStyle="text-[13px]" />
          <CustomSelect
            value={[values?.isFuture]}
            name="isFuture"
            options={dateTypeList}
            placeholder="Select type"
            onChange={(data) => setFieldValue('isFuture', data)}
          />
        </div>
        {values?.isFuture?.value === 'CUSTOM' && (
          <>
            <br />
            <div className="flex1">
              <Text text="Date:" styleContainer="mb-[6px]" textStyle="text-[13px]" />
              <CustomDatePicker
                startDate={values?.pickupDate || null}
                setStartDate={(date) => {
                  setFieldValue('pickupDate', date);
                }}
                selectsRange={false}
                minDate={new Date()}
              />
            </div>
          </>
        )}
        <br />
        <div className="flex1">
          <Text text="Carrier type:" styleContainer="mb-[6px]" textStyle="text-[13px]" />
          <CustomSelect
            value={[values?.isExpress]}
            name="isExpress"
            options={carrierCodeList}
            placeholder="Select carrier"
            onChange={(data) => setFieldValue('isExpress', data)}
          />
        </div>
      </div>
      <br />
      {fedexResponse?.transactionId && (
        <Alert
          text={(
            <>
              <div>{`TransactionId: ${fedexResponse?.transactionId}`}</div>
              <br />
              <div>{`Message: ${fedexResponse?.output?.message || ''}`}</div>
              <br />
              <div>{`Pickup confirmation code: ${fedexResponse?.output?.pickupConfirmationCode || ''}`}</div>
            </>
          )}
          type={AlertType.info}
        />
      )}
      {error && (<Alert text={error} type={AlertType.warning} />)}
    </Modal>
  );
};

FedexPickupModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible:
  PropTypes.func
};

FedexPickupModal.defaultProps = {
  visible: false,
  toggleVisible:
    () => {
    }
};

export default FedexPickupModal;
